module.exports = __webpack_public_path__ + "1469eded1cbc4676ea79b257262e4d5c.png";